<div class="preview">
  <img src="{{srcUrl}}"/>
</div>
